import { render, staticRenderFns } from "./bBlogCard.vue?vue&type=template&id=84fc1376&scoped=true"
import script from "./bBlogCard.vue?vue&type=script&lang=js"
export * from "./bBlogCard.vue?vue&type=script&lang=js"
import style0 from "./bBlogCard.vue?vue&type=style&index=0&id=84fc1376&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fc1376",
  null
  
)

export default component.exports